import { Button } from "@/components/ui/button";
import { Link } from "@remix-run/react";
import { motion } from "framer-motion";
import { CheckCheckIcon, CalendarIcon } from "lucide-react";

export const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1,
    },
  },
};

export const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};

const calLink = "https://cal.com/subhamx/boostedpins.com";

export const BookALink = () => {
  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="show"
      className="mx-auto max-w-2xl p-6"
    >
      <motion.div variants={item} className="text-center">
        <div className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-green-50 to-green-100 px-4 py-1.5 text-sm font-medium text-green-700 ring-1 ring-inset ring-green-500/20 mb-6 shadow-sm">
          <CheckCheckIcon className="h-4 w-4" />
          <span>Setup Complete</span>
        </div>

        <h1 className="mt-6 text-4xl font-extrabold tracking-tight text-gray-900">
          Welcome to{" "}
          <span className="bg-gradient-to-r from-red-600 to-red-500 bg-clip-text text-transparent">
            Boosted Pins
          </span>
          !
        </h1>
        <p className="mt-4 text-md leading-8 text-gray-600 max-w-lg mx-auto">
          You're all set! One of our team members will be in touch with you
          soon. If you'd rather schedule a call at a time that works best for
          you, feel free to schedule a call.
        </p>

        <div className="mt-10 space-y-6">
          <motion.div
            className="mt-8"
            whileHover={{ scale: 1.02 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
          >
            <Link to={calLink} target="_blank">
              <Button className="bg-gradient-to-r from-red-600 to-red-500 hover:from-red-500 hover:to-red-400 text-white font-medium rounded-xl px-5 py-4 h-auto text-md w-full flex-wrap text-wrap max-w-sm mx-auto flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transition-all">
                <CalendarIcon className="w-5 h-5" />
                Schedule Your Call Now
              </Button>
            </Link>
          </motion.div>

          <p className="text-sm text-gray-500 mt-4">
            Typically takes 15-20 minutes • Available Monday-Friday
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
};
